import React, { useContext } from "react";
import { useState } from "react";
import  './GFFTrader.css'
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import BuyBtn from "../../MiniComponents/BuyBtn/BuyBtn";
import bgImage from '../../../assets/images/bgpattern.png'
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";


export default function GFFTrader(){
   const {isloggedIn}=useContext(UserContext)
  const navigate = useNavigate()
       const handleNavigate=()=>{
        if(isloggedIn){
          navigate('/plans')
        }else{
          navigate('/signin?redirect=/plans')
        }
       }
    return(
        <div className="gfftrader__container">
          
           <div className="gfftrader__texts">
             <p>Become a GFF Trader</p>
             <p>Instantly receive your evaluation credentials and access the dashboard.</p>
           </div>
           <div className="gfftrader__buttons">
            <div className="gffbuybutton" onClick={()=>{handleNavigate()}}> 
            <BuyBtn/>
            </div>
           <div class="sectionfifth_content_text">
                                FAQ
                            </div>
            </div>
            <div className="gfftrader__bgimage">
             <img src={bgImage}             loading='lazy' />
            </div>
        </div>
    )
}